import Config from "./config";

function getReferrerOrigin() {
    try {
      const referrerUrl = new URL(document.referrer);
      return `${referrerUrl.protocol}//${referrerUrl.host}`;
    } catch (e) {
      return null; // Invalid or empty referrer
    }
  }

export function getConfigByOrigin(origin) {
    if (origin == null) {
        const isIframe = window.self !== window.top;
        origin = isIframe ? getReferrerOrigin() : window.location.origin;
        console.log({ windowOrigin: origin });
    }
    if (!Array.isArray(Config)) throw new Error('The config file must contain an array.'); //   allows for single entity config

    const blackDotConfig = Config.find(o => o.origins.includes(origin));
    if (!blackDotConfig) throw new Error(`Config not found for ${origin}`);
    return blackDotConfig;
} 